/**
 * @file Frontend logger.
 */

import loglevel from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

loglevel.setLevel(
  process.env.NODE_ENV === 'test'
    ? loglevel.levels.SILENT
    : loglevel.levels.DEBUG,
);
prefix.apply(loglevel, { template: '%t [%n] %l:' });

/**
 * Logger creator.
 *
 * @param {string} name - Logger's name.
 * @returns {loglevel.getLogger} - The logger.
 */
const getLogger = name => {
  return loglevel.getLogger(name);
};

export default getLogger;
